export const prettyScroll = (left, top, shouldSmoothScroll = true) => {
    const isSmoothScrollSupported = "scrollBehavior" in document.documentElement.style;
    if (typeof left === "number" && typeof top === "number") {
        if (shouldSmoothScroll && isSmoothScrollSupported) {
            window.scrollTo({
                behavior: "smooth",
                left: left,
                top: top,
            });
        }
        else {
            window.scrollTo(left, top);
        }
    }
};
export const isVisible = (el) => {
    if (!el)
        return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};
